
export var version = '13';
export var encription = false;


var myexports = {version,encription};
export default myexports;